const handleContactForm = (form) => {
  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {},
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input, .checkbox');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      grecaptcha.ready(async () => {
        const loadingCl = document.querySelector('.loading').classList;
        try {
          loadingCl.add('is-active');
          const response = await onFormSubmit({
            formData: {
              ...getFormValue(form, fv),
            },
            recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
            recaptchaAction: 'saveFormData',
          });
          loadingCl.remove('is-active');
          form.closest('.sc-contact-form').classList.add('show-thankyou');
          form.innerHTML = response.data.data.message;
        } catch (error) {
          loadingCl.remove('is-active');
          form.innerHTML = error.response.data.data.message;
        }
        document.querySelector('.sc-contact-form').scrollIntoView({ behavior: 'smooth' });
      });
    });
};

document.addEventListener('DOMContentLoaded', () => {
  ['contact-form-module'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleContactForm(form, formAction);
    }
  });
});
